import React from 'react';
import { useSelector } from 'react-redux';
import { getCurrencySymbolV2, numberFormatter } from 'utils/currency';

function CurrencyValueFlex({ currencyObject, onlyValue, defaultCurrency, flex = false }) {
    const selectedCurrency = useSelector((state) => state.main.selectedCurrency);

    return (
        flex ? (
            <div className="flex gap-1 w-full justify-content-end">
                
                {
                    !onlyValue && (
                        <div style={{ marginTop: `${selectedCurrency === 'aed' ? '-1px' : '0'}` }}>
                            {getCurrencySymbolV2(selectedCurrency, defaultCurrency, '11px', '11px')} 
                        </div>
                    )
                }
                <div>
                    {currencyObject ? numberFormatter.format(currencyObject[selectedCurrency === 'all' ? defaultCurrency : selectedCurrency]) : 'N/A'}
                </div>
            </div>
        ) : (
            <>
                {
                !onlyValue && (
                    <div style={{ marginTop: `${selectedCurrency === 'aed' ? '-1px' : '0'}`, marginRight: '3px' }}>
                        {getCurrencySymbolV2(selectedCurrency, defaultCurrency, '11px', '11px')} 
                    </div>
                )
                }
                {currencyObject ? numberFormatter.format(currencyObject[selectedCurrency === 'all' ? defaultCurrency : selectedCurrency]) : 'N/A'}
            </>
        )
    );
}

export default CurrencyValueFlex;
